import { useLayoutEffect, useRef } from "react";
import { gsap } from "@/lib/gsap";

export default function ReadyHeadline() {
  const root = useRef(null);
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(root.current.querySelectorAll(".rh-line"),
        { clipPath: "inset(0 0 100% 0)", yPercent: 30 },
        { clipPath: "inset(0 0 0% 0)", yPercent: 0, stagger: 0.15, duration: 1, ease: "power3.out",
          scrollTrigger: { trigger: root.current, start: "top 75%", end: "top 30%", scrub: true } });
    }, root);
    return () => ctx.revert();
  }, []);
  return (
    <div ref={root} className="bg-[#0b0d12] px-5 sm:px-8 pt-28 sm:pt-40 pb-4 sm:pb-8 overflow-hidden">
      <p className="font-mono2 text-[10px] sm:text-xs tracking-[0.35em] text-[#02AACF] mb-6">PACKAGES</p>
      <h2 data-testid="ready-headline" className="font-display font-extrabold text-white text-[clamp(2rem,6.5vw,6.5rem)] leading-[0.92] tracking-[-0.02em]">
        <span className="rh-line block">READY TO</span>
        <span className="rh-line block">BOOK.</span>
      </h2>
    </div>
  );
}
